import { buildCalculationDetailsRows } from './buildCalculationDetailsRows';
import { CalculationDetails } from './CalculationDetails';
import { CalculationDetailsInput } from './types';

export function getCalculationDetailsData(input: CalculationDetailsInput) {
  return {
    key: 'calculation-details-data',
    text: 'shared:moreInformation.items.calculationDetails.title',
    content: <CalculationDetails rows={buildCalculationDetailsRows(input)} />,
  };
}
